// extracted by mini-css-extract-plugin
module.exports = {"item":"rYV2X"};